import { useRef, useState } from "react";
import TabButtonMobile from "../TabButtonMobile/TabButtonMobile";
import "./TabListMobile.scss";
import useClickOutsideElement from "../../../Helpers/Hooks/useClickOutsideElement";

interface TabButtonProps {
  text?: string;
  propertyName?: string;
  selected?: boolean;
  onClick: () => void;
}

interface Props {
  heading?: string;
  tabButtons: TabButtonProps[];
}

const TabListMobile = ({ tabButtons, heading }: Props) => {
  const [isOpen, setIsOpen] = useState(false);
  const selected = tabButtons.filter((tb) => tb.selected)[0];
  const filtered = tabButtons.filter((tb) => !tb.selected);
  const listRef = useRef(null);
  useClickOutsideElement(() => setIsOpen(false), [listRef]);
  return (
    <div className="tab-list-mobile-norad" ref={listRef}>
      {heading && <p className="tab-list-mobile-norad__heading">{heading}</p>}
      <TabButtonMobile
        {...selected}
        isFirst
        isLast={!isOpen}
        onClick={() => setIsOpen(!isOpen)}
        chevronOpen={isOpen}
        chevronClosed={!isOpen}
      />
      {isOpen &&
        filtered.map((item, idx) => (
          <TabButtonMobile
            {...item}
            key={idx}
            isLast={idx === filtered.length - 1}
            onClick={() => {
              setIsOpen(false);
              item.onClick();
            }}
          />
        ))}
    </div>
  );
};

export default TabListMobile;
